/**
 * Delivery Domain Errors
 *
 * Typed errors for delivery operations.
 */

export type DeliveryErrorCode = 'GET_TYPES_FAILED' | 'GET_DETAILS_FAILED' | 'UNKNOWN'

export class DeliveryError extends Error {
  readonly code: DeliveryErrorCode
  readonly cause?: unknown

  constructor(code: DeliveryErrorCode, cause?: unknown) {
    super(DeliveryError.getMessageForCode(code))
    this.name = 'DeliveryError'
    this.code = code
    this.cause = cause
  }

  private static getMessageForCode(code: DeliveryErrorCode): string {
    const messages: Record<DeliveryErrorCode, string> = {
      GET_TYPES_FAILED: 'Не удалось получить службы доставки',
      GET_DETAILS_FAILED: 'Не удалось получить детали службы доставки',
      UNKNOWN: 'Что-то пошло не так, попробуйте позднее',
    }
    return messages[code]
  }
}
